import { useEffect } from 'react';

/**
 * 这里的跳转，处理两种情况:
 * 1. 用户有token，是机构用户，但没有分配机构，直接跳转到: 备课资源
 * nx.$root.isEmptyExtSchoolId
 *
 * 2. 用户有机构，是外部用户(可以调用/auth接口; 这种情况依赖 auth 接口返回)，并且，只有一个菜单: /preparation
 * nx.$root.isExternalUser && nx.$root.course.onlyPreparation
 */

export const useRootDispatch = () => {
  useEffect(() => {
    if (location.pathname !== '/preparation') {
      if (
        nx.$root.isEmptyExtSchoolId ||
        (nx.$root.isExternalUser && nx.$root.course.onlyPreparation)
      ) {
        alo7Nav.goto(`/preparation?access_token=${alo7Account.token}`);
      }
    }
  }, []);
};
